import { useEffect } from 'react';
import { isMobileOnly } from 'react-device-detect';
import Svg from 'react-inlinesvg';
import { useLocomotiveScroll } from 'react-locomotive-scroll';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation, useParams } from 'react-router-dom';

import formaLogo from '../../assets/images/icon_images/forma.svg';
import {
  handleChangeFormName,
  handleOpenModelForm,
  handleScrollVisible,
  handleVisibleHeader,
} from '../../entities/ComponentsSlice';
import { deviceSelector } from '../../entities/UserSlice';
import ButtonCall from '../../features/button-call/ButtonCall';
import ROUTES from '../../layout/routes';
import SVGelem from '../../shared/SVGelem/SVGelem';
import Wrapper from '../../shared/wrapper/Wrapper';
import { useMenuService } from '../../tools/hooks/useMenuService';
import style from './Footer.module.scss';

function Footer() {
  const device = useSelector(deviceSelector);
  const contacts = useSelector(state => state.projectinfo.contacts);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { footerLeft, footerRight, footerMiddle } = useMenuService();
  const { apartmentId } = useParams();

  const { scroll } = useLocomotiveScroll();

  const handleScrollLogo = () => {
    if (device === 'isMobile' && pathname === ROUTES.root) {
      dispatch(handleScrollVisible(true));
      window.scrollTo(0, 0);
      setTimeout(() => {
        dispatch(handleScrollVisible(false));
        dispatch(handleVisibleHeader(true));
      }, 500);
    } else if (device !== 'isMobile' && pathname === ROUTES.root) {
      dispatch(handleScrollVisible(true));
      scroll.scrollTo(0, { duration: 0, disableLerp: true });

      setTimeout(() => {
        dispatch(handleScrollVisible(false));
        dispatch(handleVisibleHeader(true));
      }, 500);
    } else {
      setTimeout(() => {
        dispatch(handleVisibleHeader(true));
      }, 500);
    }
  };

  const year = new Date().getFullYear();

  useEffect(() => {
    const footer = document.querySelector('#footer');
    const link = window.location.href;
    footer.style.display = link.includes('visual') && !apartmentId ? 'none' : 'block';
  }, [pathname, apartmentId]);

  return (
    <div id='footer' className={pathname === ROUTES.root ? style.footerContainer__landing : style.footerContainer}>
      <Wrapper>
        <div className={style.footerWrapper}>
          <div className={style.footerLeft}>
            <Link
              to={ROUTES.root}
              className={style.footerLogo}
              onClick={handleScrollLogo}
              aria-label='Moments – жилой комплекс бизнес-класса от Forma'
            >
              <SVGelem className={style.svgClass} href='#moments_white' />
            </Link>

            {device !== 'isMobile' && (
              <a className={style.formaLogoBox} target='_blanc' href='https://forma.ru/'>
                <span>Проект застройщика</span>
                <Svg className={style.formaLogo} src={formaLogo} />
              </a>
            )}
            {device === 'isMobile' && (
              <div className={style.footerNavMenu}>
                <div className={style.footerNavMenu__box}>
                  {footerLeft?.menuItems?.map(el => {
                    if (el.path.includes('contest'))
                      return (
                        <a key={el?.path} className={style.footerNavItem} href={el?.path}>
                          {el?.value}
                        </a>
                      );
                    return (
                      <NavLink key={el?.path} className={style.footerNavItem} to={el?.path}>
                        {el?.value}
                      </NavLink>
                    );
                  })}
                </div>
                <div className={style.footerNavMenu__box}>
                  {footerRight?.menuItems?.map(el => {
                    if (el?.path.includes('contest'))
                      return (
                        <a key={el?.path} className={style.footerNavItem} href={el?.path}>
                          {el?.value}
                        </a>
                      );
                    return (
                      <NavLink key={el?.path} className={style.footerNavItem} to={el?.path}>
                        {el?.value}
                      </NavLink>
                    );
                  })}
                </div>
              </div>
            )}
            {device === 'isMobile' && (
              <ButtonCall
                className={style.footerWhite__button}
                handleFuction={() => {
                  dispatch(handleOpenModelForm(true));
                  dispatch(handleChangeFormName('callbackForm'));
                }}
                text='Заказать звонок'
              />
            )}
          </div>
          {device !== 'isMobile' && footerLeft && footerMiddle && footerRight && (
            <div className={style.footerRight}>
              <div className={style.footerNavMenu}>
                <div className={style.footerNavMenu__box}>
                  {footerLeft?.menuItems?.map(el => {
                    if (el?.path.includes('contest'))
                      return (
                        <a key={el?.path} className={style.footerNavItem} href={el?.path}>
                          {el?.value}
                        </a>
                      );
                    return (
                      <NavLink key={el?.path} className={style.footerNavItem} to={el?.path}>
                        {el?.value}
                      </NavLink>
                    );
                  })}
                </div>
                <div className={style.footerNavMenu__box}>
                  {footerMiddle?.menuItems?.map(el => {
                    if (el?.path.includes('contest'))
                      return (
                        <a key={el.path} className={style.footerNavItem} href={el?.path}>
                          {el?.value}
                        </a>
                      );
                    return (
                      <NavLink key={el.path} className={style.footerNavItem} to={el?.path}>
                        {el?.value}
                      </NavLink>
                    );
                  })}
                </div>
                <div className={style.footerNavMenu__box}>
                  {footerRight?.menuItems?.map(el => {
                    if (el?.path.includes('contest'))
                      return (
                        <a key={el.path} className={style.footerNavItem} href={el?.path}>
                          {el?.value}
                        </a>
                      );
                    return (
                      <NavLink key={el.path} className={style.footerNavItem} to={el?.path}>
                        {el?.value}
                      </NavLink>
                    );
                  })}
                </div>
              </div>
              <ButtonCall
                className={style.footerWhite__button}
                handleFuction={() => {
                  dispatch(handleOpenModelForm(true));
                  dispatch(handleChangeFormName('callbackForm'));
                }}
                text='Заказать звонок'
              />
            </div>
          )}
        </div>
        <hr className={style.footerHr} />
        <div className={style.footerSubText}>
          {!isMobileOnly && (
            <div className={style.footerSubText__left}>
              <p className={style.footerSubTextPreLink}>
                Проектная декларация{' '}
                <a
                  className={style.footerSubTextLink}
                  target='_blank'
                  href='https://наш.дом.рф/сервисы/каталог-новостроек/объект/51053'
                  rel='noreferrer'
                >
                  1 очередь
                </a>
                ,{' '}
                <a
                  className={style.footerSubTextLink}
                  target='_blank'
                  href='https://наш.дом.рф/сервисы/каталог-новостроек/объект/53988'
                  rel='noreferrer'
                >
                  2 очередь
                </a>{' '}
                на сайте наш.дом.рф
              </p>
              <div className={style.footerSecondSub}>
                <a className={style.footerSubTextLink} href='https://m-a-x.design/'>
                  Дизайн-MAX
                </a>
                <a className={style.footerSubTextLink} target='_blanc' href='https://keep-calm.ru/'>
                  Разработка KEEP CALM
                </a>
                <Link className={style.footerSubTextLink} to={ROUTES.map}>
                  Карта сайта
                </Link>
                <Link className={style.footerSubTextLink} to={ROUTES.privacy}>
                  Пользовательское соглашение
                </Link>
              </div>
            </div>
          )}
          {isMobileOnly && (
            <div className={style.footerSubText__left}>
              <div className={style.footerSecondSub}>
                <a className={style.footerSubTextLink} href='https://m-a-x.design/'>
                  Дизайн-MAX
                </a>
                <a className={style.footerSubTextLink} target='_blanc' href='https://keep-calm.ru/'>
                  Разработка KEEP CALM
                </a>
                <Link className={style.footerSubTextLink} to={ROUTES.privacy}>
                  Пользовательское соглашение
                </Link>
                <Link className={style.footerSubTextLink} to={ROUTES.map}>
                  Карта сайта
                </Link>
              </div>
              <p className={style.footerSubTextPreLink}>
                Проектная декларация{' '}
                <a
                  className={style.footerSubTextLink}
                  target='_blank'
                  href='https://наш.дом.рф/сервисы/каталог-новостроек/объект/51053'
                  rel='noreferrer'
                >
                  1 очередь
                </a>
                ,{' '}
                <a
                  className={style.footerSubTextLink}
                  target='_blank'
                  href='https://наш.дом.рф/сервисы/каталог-новостроек/объект/53988'
                  rel='noreferrer'
                >
                  2 очередь
                </a>
                <br />
                на сайте{' '}
                <a
                  className={style.footerSubTextLink}
                  target='_blank'
                  href='https://наш.дом.рф/сервисы/каталог-новостроек/объект/51053'
                  rel='noreferrer'
                >
                  наш.дом.рф
                </a>
              </p>
            </div>
          )}
          <div className={style.footerSubText__right}>
            <div className={style.footerSubText__links}>
              <a className={style.footerSubText__link} href={'mailto:' + contacts.mail}>
                {contacts.mail}
              </a>
              <a className={style.footerSubText__link} href={'tel:' + contacts.phone}>
                {contacts.phone}
              </a>
            </div>

            {isMobileOnly && (
              <a className={style.formaLogoBox} target='_blanc' href='https://forma.ru/'>
                <span>Проект застройщика</span>
                <Svg className={style.formaLogo} src={formaLogo} />
              </a>
            )}

            <div className={`${style.footerSubTextLink} ${style.footerSubTextLink__notline}`}>
              © 2022{year > 2022 && <span>&ndash;{year}</span>} ООО «ФОРМА»
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  );
}

export default Footer;
